import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss']
})

export class LandingComponent implements OnInit {
  focus: any;
  focus1: any;
  public showDetalhes = false;

  constructor() { }

  ngOnInit() {}

  public show() {
    if (!this.showDetalhes) {
      this.showDetalhes = true;
    } else {
      this.showDetalhes = false;
    }
  }

}
